import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { FeedbackRequest } from '../../../models/feedback/feedback-request';
import { FeedbackService } from '../../services/feedback/feedback.service';

export const FeedbackResolver: ResolveFn<FeedbackRequest> = (route, state) => {
  return inject(FeedbackService).getFeedbackInitialDtls();
};
